import { Link }             from 'react-router-dom';
import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import ModalWrapper from '../../../../Component/ModalWrapper'
import './Style.css';

class AddSubject extends Component<any, any> {

  constructor(props: any) {
    super(props);
  }

  render() {  
    return (
      <span className="AddSubjectLink">
          <ModalWrapper setModalOpen={this.props.setModalOpen} modalIsOpen={this.props.modalIsOpen} look={this.props.look} openTitle="Create">
            {this.props.children}
          </ModalWrapper>
      </span>
    );
  }
}

export default AddSubject;
